<template>
    <div>
        <Nav />
        <SuccessPage v-if="success_page"/>
        <CheckoutView v-else @to-success-page="successPage()"/>
        <InstructionsBar v-if="displayInstructionBar"/>
    </div>
</template>

<script>
import CheckoutView from "@/components/DynamicCheckout/CheckoutView.vue";
import Nav from "@/components/DynamicCheckout/Nav.vue";
import SuccessPage from "@/components/DynamicCheckout/SuccessPage.vue";
import InstructionsBar from "@/components/InstructionsBar.vue";

export default {
    name: 'DynamicCheckoutView',
    props: ['displayInstructionBar'],
    components: {
        InstructionsBar,
        Nav,
        CheckoutView,
        SuccessPage
    },
    data() {
        return {
            success_page: false
        }
    },
    methods: {
        successPage() {
            this.success_page = true
        }
    }
}
</script>